import { render, staticRenderFns } from "./MultiChanges.vue?vue&type=template&id=88aa2874&scoped=true&"
import script from "./MultiChanges.vue?vue&type=script&lang=js&"
export * from "./MultiChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88aa2874",
  null
  
)

export default component.exports